import { Theme } from "@/shared/utils/theme/theme";
import { BUTTON_COLOR, BUTTON_VARIANT } from "@/shared/components/Button/Button.constants";
import EgwWebFont from "src/assets/EgwWebFont";
import { LANG_CODE_EN } from "@/shared/utils/multilang/constants";

export const BODY_CN_LANDING = "is-landing";

export const idCategoryTESTIMONIES = "testimonies_for_the_church";
export const idCategoryRPRAC = "real_peace_real_answers_collection";
export const idCategoryCONFLICT = "1469";
export const idCategoryCOA = "conflict_of_the_ages_series";
export const _old_idCategoryLOF = "the_life_of_faith_collection";
export const idCategoryLOF = "the_light_and_life_collection";

export const LANDING_VIEW = {
  primary: "primary",
  sda: "sda",
  big: "big",
};

export const TYPE_BOOKS_SET = {
  categories: "c",
  folders: "f",
  titles: "t",
};

export const TYPES_BOOKS_SET = Object.values(TYPE_BOOKS_SET);

export const LANDING_SEPARATOR_TYPE_BOOKS_SET = "/";
export const LANDING_SEPARATOR_VIEW = "-";

export const LandingViewDefault = LANDING_VIEW.primary;

export const MAP_LANDING_VIEW_ID_TO_CONFIG = {
  [LANDING_VIEW.primary]: {
    defaultTheme: Theme.dg.id,
    hasDarkMode: true,
    splashAsImage: false,
    buttonVariant: BUTTON_VARIANT.outline,
    buttonColor: BUTTON_COLOR.light,
    withLinkInAuthorSection: false,
    withAdventistContainerInFooter: false,
  },
  [LANDING_VIEW.sda]: {
    defaultTheme: Theme.ls.id,
    imagesSubFolder: "sda",
    splashAsImage: true,
    isArrowVariantNotSecondary: true,
    buttonVariant: BUTTON_VARIANT.outline,
    buttonColor: BUTTON_COLOR.quaternary,
    withLinkInAuthorSection: true,
    withAdventistContainerInFooter: true,
  },
};

const ConfigLOF = {
  title: "The Life of Faith Collection",
  titleMoreBooks: "<i>The Life of Faith</i> Series",
  titleShort: "LOF",
  backgroundColor: "#442A56",
  order: {
    [LANG_CODE_EN]: [108, 150, 15, 135, 29], // ["sc", "mb", "col", "mh", "ed"]
  },
};

export const SINGLE_BOOKS = ["12280", "2017"];

export const MAP_LANDING_BOOKS_SET_ID_TO_CONFIG = {
  [idCategoryTESTIMONIES]: {
    title: "Testimonies for the Church",
    titleMoreBooks: "<i>The Testimonies for the Church</i> Series",
    titleShort: "TFC",
    backgroundColor: "#013044",
    order: {
      [LANG_CODE_EN]: [116, 120, 119, 114, 113, 118, 117, 112, 115], // [vol. 1 - vol. 9]
    },
  },
  [idCategoryCOA]: {
    title: "The Conflict of the Ages Series",
    titleMoreBooks: "<i>The Conflict of the Ages</i> Series",
    titleShort: "COA",
    backgroundColor: "#013044",
    order: {
      [LANG_CODE_EN]: [84, 88, 130, 127, 132], // ["pp", "pk", "da", "aa", "gc"]
    },
  },
  [idCategoryRPRAC]: {
    onlyOneLang: true,
    hideLanguagesSection: true,
    withAdventistContainerInFooter: true,
    title: "Real Peace<br>Real Answers<br>Collection",
    titleMoreBooks: "<i>Real Peace Real Answers</i> Collection",
    titleShort: "RPRAC",
    backgroundColor: "#013044",
    order: {
      [LANG_CODE_EN]: [14669, 14661, 14668, 14665, 14664, 14663, 14662, 14667, 14670],
    },
  },
  [idCategoryCONFLICT]: {
    onlyOneLang: true,
    hideLanguagesSection: true,
    forceShowBuyBook: {
      linkBuyBook: "https://adventistbookcenter.com/the-conflict.html",
      titleBuyBook: "Buy 5-vol Set",
    },
    withAdventistContainerInFooter: true,
    title: "The Conflict",
    titleMoreBooks: "<i>The Conflict</i> Collection",
    titleShort: "CONFLICT",
    backgroundColor: "#013044",
    order: {
      [LANG_CODE_EN]: [14748, 14749, 14752, 14750, 14753],
    },
  },
  [_old_idCategoryLOF]: ConfigLOF,
  [idCategoryLOF]: ConfigLOF,
};

const IconIdLOF = EgwWebFont["the-light-and-life-collection"];

export const MAP_BOOKS_SET_ID_TO_ICON_ID = {
  [idCategoryCOA]: EgwWebFont["conflict-of-the-ages-series"],
  [_old_idCategoryLOF]: IconIdLOF,
  [idCategoryLOF]: IconIdLOF,
  [idCategoryRPRAC]: IconIdLOF,
  [idCategoryCONFLICT]: IconIdLOF,
  [idCategoryTESTIMONIES]: IconIdLOF,
};

export const LANDING_SELECTORS = {
  btnListenAuthor: "#btnListenAuthor",
  playerAuthor: "#playerAuthor",

  btnOpen: "#btnOpen",
  btnQR: ".btnQR",
  btnQRSmall: ".btnQRSmall",
  readBookBtn: ".readBookBtn",
  listenBookBtn: "#listenBookBtn",
  pdfBookBtn: "#pdfBookBtn",
  ePubBookBtn: "#ePubBookBtn",
  bookCoverClass: ".bookCoverClass",
  buttonArrowClass: ".buttonArrowClass",
  typographyCroppedClass: ".typographyCroppedClass",
  typoCropParaGhostClass: ".typoCropParaGhostClass",
  typoCropParaClass: ".typoCropParaClass",
  bookListWithLangID: "#bookListWithLangID",
  bookListWithArrowsClass: ".bookListWithArrowsClass",
  availableLanguagesBtnClass: ".availableLanguagesBtnClass",

  langUIBtn: ".langUIBtn",
  langUIDialogRootClass: ".langUIDialogRootClass",

  langDialogRootClass: ".langDialogRootClass",
  langDialogBackdrop: "#langDialogBackdrop",
  langDialogWrapperClass: ".langDialogWrapperClass",
  langDialogItemClass: ".langDialogItemClass",

  bookInfoClass: ".bookInfoClass",

  bookCarouselWrapperId: "#bookCarouselWrapperId",
  bookCarouselItemClass: ".bookCarouselItemClass",
  bookCarouselPrevId: "#bookCarouselPrevId",
  bookCarouselNextId: "#bookCarouselNextId",
  bookCarouselCurrentId: "#bookCarouselCurrentId",

  buttonInstallPWA: ".buttonInstallPWA",
  buttonShare: ".buttonShare",

  mobileMenuBlock: "#mobileMenuBlock",
};

const normalizeLandingBookTitle = (title) => {
  return title.replace(/ *\(ADAPTED\) */gi, "");
};

export const normalizeLandingBook = (book) => {
  return {
    ...book,
    translated_into: [],
    chapters: [],
    title: normalizeLandingBookTitle(book.title),
  };
};
